import React, { useState, useEffect } from 'react';
import FAQ from '../../components/FAQ';
import { useToast } from '../../contexts/ToastContext';
import { fetchFaqs } from '../../api/faqApi';
import MetaTagsUpdater from '../../components/MetaTagsUpdater';
import NoContentMessage from '../../components/NoContentMessage';

function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToast } = useToast();

  useEffect(() => {
    const fetchFaqsData = async () => {
      try {
        setLoading(true);
        const data = await fetchFaqs({ paginate: false });

        if (data.success) {
          const formattedFaqs = data.data.map(faq => ({
            id: faq.id,
            question: faq.question,
            answer: faq.answer,
          }));
          setFaqs(formattedFaqs);
        } else {
          addToast('error', data.message || 'Failed to fetch FAQs.');
        }
      } catch (e) {
        console.error("Error fetching FAQs:", e);
        addToast('error', 'Failed to load FAQs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchFaqsData();
  }, [addToast]);

  return (
    <div className="pt-20 bg-bg-dark min-h-screen text-text-gray">
      <MetaTagsUpdater pageKey="FAQ" />
      <div className="max-w-6xl mx-auto px-5 py-8">
        <h1 className="text-4xl font-bold text-center text-text-white mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
          Frequently Asked Questions
        </h1>

        <div className="max-w-3xl mx-auto">
          {loading ? (
            <div className="space-y-4">
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="bg-gray-800 p-6 rounded-lg animate-pulse">
                  <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-gray-700 rounded w-full"></div>
                </div>
              ))}
            </div>
          ) : faqs.length > 0 ? (
            <FAQ faqs={faqs} />
          ) : (
            <NoContentMessage message="No FAQs found." /> // Use common component
          )}
        </div>
      </div>
    </div>
  );
}

export default FAQPage;